function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
const SvgIconPhone = props => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 37",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.841 35.51C9.798 40.57-7.343 7.19 3.451 1.56L6.609 0l5.235 10.23-3.121 1.54c-3.281 1.77 3.553 15.14 6.909 13.51.136-.06 3.083-1.51 3.094-1.52l5.278 10.2c-.012.01-2.982 1.47-3.163 1.55zm.399-29.23a9.49 9.49 0 016.376 11.81l-2.69-.8a6.681 6.681 0 00-.528-5.09 6.65 6.65 0 00-3.962-3.22zM19.838 11a4.542 4.542 0 012.71 2.21c.6 1.11.694 2.35.36 3.48l-4.373-1.31zm2.003-6.74c2.84.85 5.359 2.78 6.881 5.6 1.52 2.82 1.757 5.99.912 8.83l2.758.83a14.45 14.45 0 00-1.141-11.03 14.41 14.41 0 00-8.587-6.99z"
  }));
};
SvgIconPhone.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  fill: PropTypes.string,
  label: PropTypes.string
} : {};
export default SvgIconPhone;